import { render, staticRenderFns } from "./BiodiversityMasterPlan.vue?vue&type=template&id=50989111"
import script from "./BiodiversityMasterPlan.vue?vue&type=script&lang=js"
export * from "./BiodiversityMasterPlan.vue?vue&type=script&lang=js"
import style0 from "./BiodiversityMasterPlan.vue?vue&type=style&index=0&id=50989111&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports